export default {
    currentUser(state: any) {
        return state.user;
    },
    isAuthenticated(state: any) {
        return state.isAuthenticated;
    }
};